import { Stack, Typography } from "@mui/material";
const TableErrorMessage = () => {
  return (
    <Stack sx={{ my: 10 }}>
      <Typography variant="h6" sx={{ textAlign: "center" }}>
        Something went wrong
      </Typography>
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        Please try again later.
      </Typography>
    </Stack>
  );
};

export default TableErrorMessage;
